module.exports = __webpack_public_path__ + "static/queenmaeve-eda2065d8cbfd231045ccc62b7361d85.jpg";